export default "__VITE_ASSET__B$RtmPAZ__"